import { M3DETCONDIPROMO } from "./M3DETCONDIPROMO.class";

export class M3CONDIPROMO{
    public IdPromocion:number;
    public IdCondicion:number;
    public Concepto:string;
    public Valor:string;
    public JAdicionales:string;

    public M3DETCONDIPROMO: Array<M3DETCONDIPROMO>;

}